import { ValueFieldsProps } from "@/pages/talent/goals/components/key-result-form.types.ts";
import { Select, SelectItem, Stack } from "@skailer-com/uikit";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export function BooleanValueFields({ formHook, isCreating }: ValueFieldsProps) {
  const { t } = useTranslation();
  const { control } = formHook;

  const booleanOptions: SelectItem[] = [
    { id: "1", title: t("common:yes") },
    { id: "0", title: t("common:no") },
  ];

  return (
    <Stack>
      <Controller
        control={control}
        name="start_value"
        render={({ field: { value, onChange } }) => (
          <Select
            label={t("goals:start_value")}
            emptyTitle={t("common:select")}
            options={booleanOptions}
            value={value?.toString()}
            onChange={(v) => onChange(v === "1" ? 1 : 0)}
          />
        )}
      />
      {isCreating && (
        <Controller
          control={control}
          name="current_value"
          render={({ field: { value, onChange } }) => (
            <Select
              label={t("goals:current_value")}
              emptyTitle={t("common:select")}
              options={booleanOptions}
              value={value?.toString()}
              onChange={(v) => onChange(v === "1" ? 1 : 0)}
            />
          )}
        />
      )}
      <Controller
        control={control}
        name="target_value"
        render={({ field: { value, onChange } }) => (
          <Select
            label={t("goals:target_value")}
            emptyTitle={t("common:select")}
            options={booleanOptions}
            value={value?.toString()}
            onChange={(v) => onChange(v === "1" ? 1 : 0)}
          />
        )}
      />
    </Stack>
  );
}
